var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v("Gewünschter Titel des Terminkalenders")]),_c('inputText',{attrs:{"data":_vm.title,"label":"","callback":function(value) { _vm.setTitle(value);}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }